const appRoles = {
	admin: "ITK.Admin",
	networkPartner: "ITK.NetworkPartner",
	cst: "ITK.CST",
};

export default appRoles;
